import { DateUtils } from "utils";

export const formatFileSize = (bytes?: number): string => {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const formatDate = (dateStr?: string): string => {
  if (!dateStr) return "";
  const date = parseContractDate(dateStr);
  if (!date) return "";
  return DateUtils.formatDateDisplay(date);
};

export const parseContractDate = (dateStr?: string): Date | null => {
  if (!dateStr) return null;

  const [yearString = "", monthString = "", dayString = ""] = dateStr.split("T")[0]?.split("-") || [];
  const year = Number(yearString);
  const month = Number(monthString);
  const day = Number(dayString);

  if (year && month && day) {
    return new Date(year, month - 1, day);
  }

  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? null : date;
};

export const formatContractDateForApi = (value: Date | null): string | undefined => {
  if (!value) return undefined;

  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};
